import { useKeycloak } from '@lib/keycloak.js'
import { createRouter, createWebHistory } from 'vue-router'
import ROUTES from './routes.js'

const routes = [
    {
        path: '/',
        name: ROUTES.HOME,
        component: () => import('@views/TicketHolderPage.vue'),
        meta: {
            rights: [ 'customer-care' ],
            nav: true,
            display: 'Übersicht'
        }
    },
    {
        path: '/accounting',
        name: ROUTES.ACCOUNTING,
        component: () => import('@views/CompanyPage.vue'),
        meta: {
            rights: [ 'administrator', 'corporate-supervisor' ],
            nav: true,
            display: 'Abrechnung'
        }
    },
    {
        path: '/users',
        name: ROUTES.USERS,
        component: () => import('@views/UserManagementPage.vue'),
        meta: {
            rights: [ 'user-management', 'corporate-supervisor' ],
            nav: true,
            display: 'Benutzer'
        }
    },
    {
        path: '/applications',
        children: [
            {
                path: 'requests',
                name: ROUTES.APPLICATION_REQUESTS,
                component: () => import('@views/application-requests/ApplicationRequestsPage.vue'),
                meta: {
                    rights: [ 'customer-care' ],
                    nav: true,
                    display: 'Anträge'
                }
            }
        ]
    },
    {
        path: '/ticket-holder',
        name: ROUTES.TICKETHOLDER,
        component: () => import('@views/TicketHolderDetailPage.vue'),
        meta: {
            rights: [ 'customer-care' ],
            nav: false,
            display: 'Fahrkarteninhaber',
            parentPath: '/',
        }
    },
    {
        path: '/products',
        name: ROUTES.PRODUCT,
        component: () => import('@views/ProductSelectionPage.vue'),
        meta: {
            nav: false,
            display: 'Produktauswahl',
            parentPath: '/ticket-holder',
        }
    },
    {
        path: '/ticket-creation/:productVariantId',
        name: ROUTES.TICKETCREATION,
        component: () => import('@views/TicketCreationPage.vue'),
        meta: {
            nav: false,
            display: 'Berechtigung anlegen',
            parentPath: '/products',
        }
    },
    // catch all non existing routes
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        // always redirect to landing page
        beforeEnter: (to, from, next) => {
            next({ path: '/', query: to.query })
        }
    }
]
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

router.beforeEach((to/*, from*/) => {
    const keycloak = useKeycloak()
    // check if the user is allowed to navigate to the given page
    const rightsToRoute = to.meta.rights
    if (rightsToRoute && !rightsToRoute.find(right => keycloak.hasResourceRole(right))) {
        return _getAllowedDefaultRoute()
    }
})

const _getAllowedDefaultRoute = () => {
    const keycloak = useKeycloak()

    // if not, send the user to the the first page he is allowed to access
    for (const route of routes) {
        const routeHasRights = !!route.meta?.rights
        const routeIsNavigatable = !!route.meta?.nav && !route.meta?.explicitNoNav
        const userIsAllowedToUseRoute = !!route.meta?.rights?.find(right => keycloak.hasResourceRole(right))

        // 1. the route needs to be accesible by navigation
        // 2. either the route needs no rights or the user is allowed to use it
        if (routeIsNavigatable && (!routeHasRights || userIsAllowedToUseRoute)) {
            return route
        } else {
            console.warn('user is not allowed to access route')
        }
    }

    // if even that fails, try to redirect to the landing page
    // -> possible endless loop if the user does not have the right to go to the landing page
    return { name: ROUTES.HOME }
}

export default router

export {
    ROUTES
}
